/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} History_Transfer_Review_HelperInputs */

const en_us2_history_transfer_review_helper = /** @type {(inputs: History_Transfer_Review_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check each exercise. What we could not match confidently starts as "Don't import". Pick the right one or leave it out.`)
};

const pt_br2_history_transfer_review_helper = /** @type {(inputs: History_Transfer_Review_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confira cada exercício. O que não deu para reconhecer com segurança começa como "Não importar". Escolha o certo ou deixe de fora.`)
};

const es_419_history_transfer_review_helper = /** @type {(inputs: History_Transfer_Review_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisa cada ejercicio. Lo que no pudimos reconocer con seguridad empieza como "No importar". Elige el correcto o déjalo fuera.`)
};

const pt_pt2_history_transfer_review_helper = /** @type {(inputs: History_Transfer_Review_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifica cada exercício. O que não foi possível reconhecer com segurança começa como "Não importar". Escolhe o certo ou deixa-o de fora.`)
};

const fr_fr2_history_transfer_review_helper = /** @type {(inputs: History_Transfer_Review_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vérifie chaque exercice. Ce qu'on n'a pas pu reconnaître avec certitude commence en « Ne pas importer ». Choisis le bon ou laisse-le de côté.`)
};

const de_de2_history_transfer_review_helper = /** @type {(inputs: History_Transfer_Review_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prüf jede Übung. Was wir nicht sicher zuordnen konnten, steht zunächst auf „Nicht importieren“. Wähl die richtige oder lass sie weg.`)
};

const it_it2_history_transfer_review_helper = /** @type {(inputs: History_Transfer_Review_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controlla ogni esercizio. Quelli che non abbiamo riconosciuto con certezza partono come "Non importare". Scegli quello giusto o lascialo fuori.`)
};

/**
* | output |
* | --- |
* | "Check each exercise. What we could not match confidently starts as \"Don't import\". Pick the right one or leave it out." |
*
* @param {History_Transfer_Review_HelperInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const history_transfer_review_helper = /** @type {((inputs?: History_Transfer_Review_HelperInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<History_Transfer_Review_HelperInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_history_transfer_review_helper(inputs)
	if (locale === "es-419") return es_419_history_transfer_review_helper(inputs)
	if (locale === "pt-PT") return pt_pt2_history_transfer_review_helper(inputs)
	if (locale === "fr-FR") return fr_fr2_history_transfer_review_helper(inputs)
	if (locale === "de-DE") return de_de2_history_transfer_review_helper(inputs)
	if (locale === "it-IT") return it_it2_history_transfer_review_helper(inputs)
	return en_us2_history_transfer_review_helper(inputs)
});
export { history_transfer_review_helper as "history-transfer.review_helper" }